<template>
  <Section :content="whatIsSolid" />
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import Section from '@/components/section.vue';
export default {
  name: 'SectionWhatIsSolid',
  components: {
    Section,
  },
  data() {
    return {
      whatIsSolid: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'What is Solid?',
        paragraphs: [
          'Solid is a specification that lets people store their data securely in decentralized data stores called Pods. Pods are like secure personal web servers for data. When data is stored in someone\'s Pod, they control which people and applications can access it.',
          'Solid Pods are data sources independent of application providers, and store data in an interoperable format so that different applications can use the same data.'
        ],
        id: 'what-is-solid',
        image: 'interoperability.png',
        videoId: '',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-light-grad',
        learnMoreLink: '/solid',
        /*html: 
          '<div><a href="https://solidproject.org/" target="_blank" class="btn font-weight-bold btn-link btn-lg text-dark" target="_self" style="text-decoration: none; padding-left: 0px !important;">' +
          'Learn More ' +
          '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-arrow-right fa-w-14"><path fill="currentColor" d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z" class=""></path></svg></a></div>'
*/
      },
    }
  }
};
</script>
